export const tasksPartnerFilterTitles = [
  { value: 'all', label: 'Всі завдання' },
  { value: 'main', label: 'Мої завдання' },
  { value: 'partner', label: 'Завдання точок продажу' },
];
